import * as Yup from 'yup';


export const login = () => ({
    user: "",
    password: ""
})


export const loginSchema = Yup.object().shape({

    user: Yup.string()
                .required('User Name is Required'),

    password: Yup.string()
                .required('Password is Required'),

  });
